import React from 'react';

interface HeaderProps {
  title: string;
  description: string;
}
const Header = ({ title, description }: HeaderProps) => (
  <>
    <h1 className='text-4xl font-bold'>{title}</h1>
    <p className='text-muted-foreground'>{description}</p>
  </>
);

export default Header;
